export abstract class EshopFormIds {
  static readonly ALTERNATIVE_FUEL_TYPE_CHECKBOX = "alternative_fuel_type_checkbox";
  static readonly NATURAL_GAS_RADIO_ARRAY_OPTION = "natural_gas_radio_array_option";
  static readonly BIO_METHANE_RADIO_ARRAY_OPTION = "bio_methane_radio_array_option";
  static readonly CARD_PAYMENT_RADIO_ARRAY_OPTION = "card_payment_radio_array_option";
  static readonly GOOGLE_PAY_PAYMENT_RADIO_ARRAY_OPTION = "google_pay_payment_radio_array_option";
  static readonly BANK_TRANSFER_PAYMENT_RADIO_ARRAY_OPTION = "bank_transfer_payment_radio_array_option";
}
